import { render, staticRenderFns } from "./DashboardAnalyticsBox.vue?vue&type=template&id=1f81fe75"
import script from "./DashboardAnalyticsBox.vue?vue&type=script&lang=js"
export * from "./DashboardAnalyticsBox.vue?vue&type=script&lang=js"
import style0 from "./DashboardAnalyticsBox.vue?vue&type=style&index=0&id=1f81fe75&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports